import React, {useEffect} from 'react';
import "aos/dist/aos.css";
import AOS from "aos";
import '../style/apartment.css';
import "../style/officecleaning.css";
import { Typography } from "@mui/material";
import { FaRegCheckCircle } from "react-icons/fa";
import { LazyLoadImage } from "react-lazy-load-image-component";
import imgServ1 from "../images/photo-apartment2.png";
import imgServ2 from "../images/photo-apartment1.png";
import imgServ3 from "../images/photo-apartment4.png";
import imgServ4 from "../images/photo-apartment3.png";
import Infokontakt from "../components/Infokontakt";
import Footer from "../components/Footer";

function Apartmentcleaning() {
    useEffect(() => {
        AOS.init();
        window.scrollTo(0, 0);
      }, []);
    
      return (
        <div className="continer-office-cleaning">
          <div className="cover-img-content-apartment">
            <div className="photocontent-box">
              <Typography
                variant="h3"
                sx={{
                  color: "var(--mainColor)",
                  fontFamily: "var(--fontFamily)",
                  fontWeight: "medium",
                }}
              >
                Wohnungsreinigung
              </Typography>
            </div>
          </div>
          <div className="content-text-for-services">
            <div className="text-service-first">
              <Typography
                variant="h5"
                gutterBottom
                sx={{
                  color: "var(--mainColorLight)",
                  fontFamily: 'var(--fontFamily)',
        fontWeight: '700',
                }}
              >
                Wohnungsreinigung für ein Zuhause zum Wohlfühlen

              </Typography>
            </div>
            <div
              className="text-body-service"
              data-aos="zoom-out"
              data-aos-anchor-placement="top-bottom"
              data-aos-offset="100"
              data-aos-duration="1000"
              data-aos-once="true"
            >
              <Typography
                gutterBottom
                variant="body2"
                sx={{
                  fontWeight: "normal",
                  fontFamily: 'var(--fontFamily)',
                   color:'var(--textColor)'
                }}
              >
                 Ein sauberes Zuhause bedeutet Lebensqualität. Unsere professionelle Wohnungsreinigung sorgt für Ordnung, Hygiene und ein gepflegtes Wohnambiente – zuverlässig, gründlich und diskret.<br/> 
                <br /> Unsere erfahrenen Reinigungsteams reinigen alle Wohnbereiche mit modernster Technik und umweltfreundlichen Reinigungsmitteln. Von Böden und Oberflächen bis hin zu Küche und Bad – wir kümmern uns um jedes Detail. Ob regelmäßige Reinigung oder individuelle Sonderleistung: Wir passen unseren Service flexibel an Ihre Wünsche an. <br/>
                <br />Verlassen Sie sich auf höchste Reinigungsstandards für ein Zuhause, in dem Sie sich rundum wohlfühlen. <br/>
              
           </Typography>
            </div>
            <div className="textandphoto-service">
              <div
                className="text-service-line"
                data-aos="fade-right"
                data-aos-offset="50"
                data-aos-duration="1000"
              >
                <h4>Ihre Vorteile auf einen Blick</h4>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontFamily: 'var(--fontFamily)',
                    color:'var(--textColor)'
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                  Professionelle Reinigung für alle Wohnungsarten
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontFamily: 'var(--fontFamily)',
                    color:'var(--textColor)'
                  }}
               
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                Gründliche und hygienische Ergebnisse
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontFamily: 'var(--fontFamily)',
                   color:'var(--textColor)'
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                  Zuverlässiger & pünktlicher Service
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontFamily: 'var(--fontFamily)',
                    color:'var(--textColor)'
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                 Umweltfreundliche Reinigungsmittel
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontFamily: 'var(--fontFamily)',
                    color:'var(--textColor)'
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                 Transparente Preise & Top-Bewertungen
                </Typography>
               
              </div>
              <div className="photo-service-line">
                <div
                  className="photo1-service"
                  data-aos="flip-left"
                  data-aos-offset="50"
                  data-aos-duration="1000"
                >
                  <LazyLoadImage
                    src={imgServ1}
                    style={{
                      width: "100%",
                      borderRadius: "10px",
                      boxShadow: " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                    }}
                  />
                </div>
                <div
                  className="photo2-service"
                  data-aos="flip-right"
                  data-aos-offset="50"
                  data-aos-duration="1000"
                >
                  <LazyLoadImage
                    src={imgServ2}
                    style={{
                      width: "100%",
                      borderRadius: "10px",
                      boxShadow: " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="content-text-for-services2">
            <div className="text-service-first">
              <Typography
                variant="h5"
                gutterBottom
                sx={{
                  color: "var(--mainColorLight)",
                  fontFamily: 'var(--fontFamily)',
                  fontWeight: '700',
                }}
              >
                Entdecken Sie die Vorteile unserer Wohnungsreinigung!
              </Typography>
            </div>
            <div className="text-body-service2">
              <div
                className="text-for-service-body"
                data-aos="fade-right"
                data-aos-anchor-placement="top-bottom"
                data-aos-offest="200"
                data-aos-duration="1000"
              >
                <Typography gutterBottom variant="body2" sx={{
                   fontFamily: 'var(--fontFamily)',
                   color:'var(--textColor)'
                }}>
                  
Unsere Verpflichtung zur Qualität spiegelt sich in all unseren Dienstleistungen wider, einschließlich unserer hoch bewerteten Wohnungsreinigungsservices. Egal, ob Sie einen zuverlässigen Wohnungsreinigungsdienst in Ihrer Nähe suchen oder professionelle Reinigungslösungen für gewerbliche Zwecke benötigen, wir sind für Sie da. Zusätzlich zu unseren Reinigungsdiensten unterstützen wir auch soziale und wohltätige Zwecke in unserer Gemeinschaft. Kontaktieren Sie uns noch heute, um eine Reinigungserfahrung zu erleben, die alle Ihre Erwartungen übertrifft! </Typography>
              </div>
            </div>
            <div className="textandphoto-service2">
              <div
                className="text-service-line2"
                data-aos="fade-right"
                data-aos-offset="300"
                data-aos-duration="1000"
              >
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    fontFamily: 'var(--fontFamily)',
                    color:'var(--textColor)'
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                 Professionelle Reinigung für alle Arten von Wohnungsreinigung
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "var(--textColor)",
                    fontFamily: "var(--fontFamily)",
                  }}
                 
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                 Gründliche Entfernung von Schmutz, Staub und Rückständen
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "var(--textColor)",
                    fontFamily: "var(--fontFamily)",
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                Streifenfreie und glänzende Ergebnisse
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "var(--textColor)",
                    fontFamily: "var(--fontFamily)",
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                 Pünktliche und zuverlässige Dienstleistungen
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "var(--textColor)",
                    fontFamily: "var(--fontFamily)",
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                  Wettbewerbsfähige Preise und transparente Abrechnung
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "var(--textColor)",
                    fontFamily: "var(--fontFamily)",
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                  Hochbewertete Reinigung.
                </Typography>
                <Typography
                  gutterBottom
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    color: "var(--textColor)",
                    fontFamily: "var(--fontFamily)",
                  }}
                >
                  <FaRegCheckCircle
                    className="checkicon"
                    style={{ marginRight: "10px" }}
                  />{" "}
                  Wohnungsreinigungsdienst in der Nähe von Städten
                </Typography>
              </div>
              <div className="photo-service-line2">
                <div
                  className="photo3-service"
                  data-aos="flip-left"
                  data-aos-offset="200"
                  data-aos-duration="1000"
                >
                  <LazyLoadImage
                    src={imgServ4}
                    style={{
                      width: "100%",
                      borderRadius: "10px",
                      boxShadow: " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                    }}
                  />
                </div>
                <div
                  className="photo4-service"
                  data-aos="flip-right"
                  data-aos-offset="200"
                  data-aos-duration="1000"
                >
                  <LazyLoadImage
                    src={imgServ3}
                    style={{
                      width: "100%",
                      borderRadius: "10px",
                      boxShadow: " rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
    
          <Infokontakt />
          <Footer />
        </div>
      );
}

export default Apartmentcleaning
